import React from 'react';
import {connect} from 'react-redux';
import {submit, isSubmitting} from 'redux-form';

import {AddEmploymentForm, SubmitButton} from './components';
import {default as Modal, withModal} from 'components/Modal';

import {MODALS} from 'ducks/bookings';

import './styles.css';

class AddEmploymentModal extends React.Component<any> {
  triggerSubmit = () => this.props.submit('addEmployment');

  render() {
    const {
      form: {submitting},
      data: {agreementUserId, affordabilityId, bookingId, locationRef}
    } = this.props;

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        type={Modal.EXTRA_SMALL}
        className="AddEmploymentModal">
        <Modal.Header heading="Add Employment" />
        <Modal.Body>
          <AddEmploymentForm
            agreementUserId={agreementUserId}
            affordabilityId={affordabilityId}
            bookingId={bookingId}
            locationRef={locationRef}
          />
        </Modal.Body>
        <Modal.Footer>
          <SubmitButton
            submitting={submitting}
            triggerSubmit={this.triggerSubmit}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    form: {
      submitting: isSubmitting('addEmployment')(state)
    }
  };
};

const mapDispatchToProps = {submit};

export default connect(mapStateToProps, mapDispatchToProps)(
  withModal(MODALS.ADD_EMPLOYMENT)(AddEmploymentModal)
);
